module.exports = __webpack_public_path__ + "static/img/image069.d31e5fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image069.png
// module id = ybI6
// module chunks = 1